document.addEventListener("DOMContentLoaded", async function () {
    console.log("Modal pre-checkout: Iniciando configuración...");
    
    const modalElement = document.querySelector(".modal-checkout-address") || null;
    const closeModalButton = document.getElementById("close-modal-checkout") || null;
    const backModalButton = document.getElementById("btn-close-modal") || null;
    const saveCheckoutButton = document.getElementById("btn-save-pre-checkout") || null;
    
    console.log("Modal pre-checkout: Elementos encontrados:", {
        modalElement: !!modalElement,
        closeModalButton: !!closeModalButton,
        backModalButton: !!backModalButton,
        saveCheckoutButton: !!saveCheckoutButton
    });


    const emailInput = document.getElementById("email-client");
    const firstNameInput = document.getElementById("first-name-client");
    const lastNameInput = document.getElementById("last-name-client");
    /** Documento de identidad: `RUT-client` o `dni-client` (mismo campo, ids distintos por tienda). */
    const dniInput = document.getElementById("RUT-client") || document.getElementById("dni-client");
    const addressInput = document.getElementById("address-client");
    const phoneInput = document.getElementById("phone-client");
    const level1Select = document.getElementById("level1-client");
    const level2Select = document.getElementById("level2-client");
    const level3Select = document.getElementById("level3-client");

    const itemsCartContainer = document.getElementById("items-cart-pop-up");
    const totalPriceContainer = document.getElementById("price-with-discount-cart-pop-up");

    let cartData = null;
    let productsArray = [];
    let geographicData = null;
    const pendingCartStorageKey = `dockers-pending-cart:${window.location.hostname}`;
    const pendingCartMaxAgeMs = 7 * 24 * 60 * 60 * 1000;
    /** Borrador en localStorage: el tema u otras integraciones pueden usar `modalPrecheckoutData`. */
    const PRECHECKOUT_DRAFT_STORAGE_KEYS = ["modalPrecheckoutDraft", "modalPrecheckoutData"];
    const GEO_LEVELS_STORAGE_KEY = "geographicLevels";
    let precheckoutDraftSaveTimer = null;
    let geographicListenersBound = false;
    let validationListenersBound = false;
    let modalOpenCartRefreshTimer = null;

    function gid(v) {
        return v == null || v === "" ? "" : String(v);
    }

    /**
     * Asigna la opción de un <select> de forma que el navegador muestre el texto elegido (no solo el placeholder).
     * `select.value = id` a veces no actualiza la vista; `selectedIndex` + segundo intento suele corregirlo.
     */
    function applySelectValue(selectEl, valueId) {
        if (!selectEl) return false;
        const v = gid(valueId);
        const opts = Array.from(selectEl.options);
        if (!v) {
            selectEl.selectedIndex = 0;
            opts.forEach((o, i) => {
                const on = i === 0;
                o.selected = on;
                if (on) o.setAttribute("selected", "selected");
                else o.removeAttribute("selected");
            });
            return true;
        }
        const idx = opts.findIndex((o) => gid(o.value) === v);
        if (idx < 0) return false;
        opts.forEach((o, i) => {
            const on = i === idx;
            o.selected = on;
            if (on) o.setAttribute("selected", "selected");
            else o.removeAttribute("selected");
        });
        selectEl.selectedIndex = idx;
        if (gid(selectEl.value) !== v) {
            selectEl.value = v;
        }
        const reassert = () => {
            if (!selectEl || !selectEl.isConnected) return;
            const fresh = Array.from(selectEl.options);
            const i2 = fresh.findIndex((o) => gid(o.value) === v);
            if (i2 < 0) return;
            selectEl.selectedIndex = i2;
            selectEl.value = v;
            fresh.forEach((o, i) => {
                o.selected = i === i2;
            });
        };
        requestAnimationFrame(reassert);
        requestAnimationFrame(() => requestAnimationFrame(reassert));
        return true;
    }

    function normName(s) {
        return String(s || "")
            .trim()
            .toUpperCase()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "");
    }

    /**
     * Detecta si una cadena luce como un código ISO 3166-2 (p.ej. "PE-ICA", "PE-LMA").
     * Tolerante: acepta minúsculas, espacios y guiones distintos.
     */
    function looksLikeRegionCode(s) {
        const v = String(s || "").trim().toUpperCase();
        return /^[A-Z]{2}-[A-Z0-9]{2,4}$/.test(v);
    }

    /**
     * Resuelve el código ISO de región (p.ej. "PE-ICA") a partir de cualquier valor:
     *   - código directo: "PE-ICA", "pe-ica", "PE_ICA" → "PE-ICA"
     *   - nombre: "Ica", "ICA", "Apurímac" → "PE-APU"
     *   - diccionario en cualquier dirección: { "PE-ICA": "Ica" } o { "ICA": "PE-ICA" }
     */
    function resolveProvinceCode(rawValue, map) {
        const raw = String(rawValue || "").trim();
        if (!raw) return "";

        const upper = raw.toUpperCase().replace(/_/g, "-");

        // 1) Si ya parece un código ISO, devolverlo normalizado.
        if (looksLikeRegionCode(upper)) return upper;

        // 2) Buscar en el diccionario probando ambas direcciones.
        if (map && typeof map === "object") {
            const target = normName(raw);
            for (const [k, v] of Object.entries(map)) {
                const keyUp = String(k || "").toUpperCase();
                const valStr = String(v == null ? "" : v);
                const valUp = valStr.toUpperCase();

                // Caso A: { código: nombre }  →  buscamos por nombre y devolvemos el código.
                if (looksLikeRegionCode(keyUp) && normName(valStr) === target) {
                    return keyUp;
                }
                // Caso B: { nombre: código }  →  buscamos por nombre (clave) y devolvemos el valor (código).
                if (looksLikeRegionCode(valUp) && normName(k) === target) {
                    return valUp;
                }
                // Caso C: el usuario pasó directamente la clave (sea código o nombre).
                if (normName(k) === target) {
                    if (looksLikeRegionCode(valUp)) return valUp;
                    if (looksLikeRegionCode(keyUp)) return keyUp;
                }
            }
        }

        return "";
    }

    function normalizePrecheckoutDraftShape(d) {
        if (!d || typeof d !== "object") return d;
        return {
            ...d,
            email: d.email ?? "",
            firstName: d.firstName ?? "",
            lastName: d.lastName ?? "",
            dni: gid(d.dni ?? d.dni2),
            address: d.address ?? "",
            phone: d.phone ?? "",
            level1: gid(d.level1 ?? d.level_1),
            level2: gid(d.level2 ?? d.level_2),
            level3: gid(d.level3 ?? d.level_3),
            level1Name: d.level1Name ?? d.level_1Name ?? "",
            level2Name: d.level2Name ?? d.level_2Name ?? "",
            level3Name: d.level3Name ?? d.level_3Name ?? "",
            geoCountry: d.geoCountry != null ? String(d.geoCountry) : ""
        };
    }

    function draftStorageCompleteness(d) {
        if (!d || typeof d !== "object") return 0;
        let n = 0;
        if (gid(d.email)) n += 1;
        if (gid(d.level3) || normName(d.level3Name)) n += 4;
        if (gid(d.level2) || normName(d.level2Name)) n += 2;
        if (gid(d.level1) || normName(d.level1Name)) n += 2;
        return n;
    }

    function peekPrecheckoutDraft() {
        let best = null;
        let bestScore = -1;
        for (const key of PRECHECKOUT_DRAFT_STORAGE_KEYS) {
            try {
                const raw = localStorage.getItem(key);
                if (!raw) continue;
                const parsed = JSON.parse(raw);
                if (!parsed || typeof parsed !== "object") continue;
                const sc = draftStorageCompleteness(parsed);
                if (sc > bestScore) {
                    bestScore = sc;
                    best = parsed;
                }
            } catch (e) {
                continue;
            }
        }
        if (!best) return null;
        return normalizePrecheckoutDraftShape(best);
    }

    if (modalElement) {
        modalElement.style.display = "none";
    }

    const diccionaryData = {
        provincesMap: {
            "PE-AMA": "Amazonas",
            "PE-ANC": "Ancash",
            "PE-APU": "Apurímac",
            "PE-ARE": "Arequipa",
            "PE-AYA": "Ayacucho",
            "PE-CAJ": "Cajamarca",
            "PE-CAL": "El Callao",
            "PE-CUS": "Cusco",
            "PE-HUV": "Huancavelica",
            "PE-HUC": "Huánuco",
            "PE-ICA": "Ica",
            "PE-JUN": "Junín",
            "PE-LAL": "La Libertad",
            "PE-LAM": "Lambayeque",
            "PE-LIM": "Lima (Department)",
            "PE-LMA": "Lima (Metropolitan)",
            "PE-LOR": "Loreto",
            "PE-MDD": "Madre de Dios",
            "PE-MOQ": "Moquegua",
            "PE-PAS": "Pasco",
            "PE-PIU": "Piura",
            "PE-PUN": "Puno",
            "PE-SAM": "San Martín",
            "PE-TAC": "Tacna",
            "PE-TUM": "Tumbes",
            "PE-UCA": "Ucayali"
        },
        countries: {
            PE: "PE"
        }
    };

    async function showModal() {
        console.log("Modal pre-checkout: Abriendo modal, refrescando carrito...");
        await loadCartData();
        await ensureGeographicMatchesDraft(peekPrecheckoutDraft());
        restorePrecheckoutDraft();
        if (modalElement) {
            modalElement.style.display = "flex";
            console.log("Modal pre-checkout: Modal mostrado");
        } else {
            console.error("Modal pre-checkout: No se pudo mostrar el modal - elemento no encontrado");
        }
        requestAnimationFrame(() => {
            const draft = peekPrecheckoutDraft();
            if (draft && geographicData?.thirdLevel) {
                restoreGeographicLevelsFromDraft(draft);
            }
            validateForm();
            requestAnimationFrame(() => {
                const d2 = peekPrecheckoutDraft();
                if (d2 && geographicData?.thirdLevel) {
                    restoreGeographicLevelsFromDraft(d2);
                }
                validateForm();
            });
        });
    }

    // Exponer función global por si se necesita abrir el modal desde otros scripts
    window.showModalPrecheckout = showModal;

    function closeModal() {
        if (modalElement) modalElement.style.display = "none";
    }

    function getCartFulfillmentGroupsApi() {
        return window.theme && window.theme.cartFulfillmentGroupsApi
            ? window.theme.cartFulfillmentGroupsApi
            : null;
    }

    function canProceedWithSelectedGroup() {
        const groupingApi = getCartFulfillmentGroupsApi();

        if (!groupingApi || !groupingApi.isActive()) {
            return true;
        }

        if (groupingApi.canProceedToCheckout()) {
            return true;
        }

        groupingApi.showSelectionRequiredMessage();
        return false;
    }

    function getCheckoutItems(items) {
        const groupingApi = getCartFulfillmentGroupsApi();

        if (!groupingApi || !groupingApi.isActive()) {
            return items;
        }

        return groupingApi.getSelectedCartItems(items);
    }

    function getPendingCartSnapshot() {
        try {
            const rawValue = localStorage.getItem(pendingCartStorageKey);

            if (!rawValue) {
                return null;
            }

            const parsedValue = JSON.parse(rawValue);

            if (!parsedValue || !Array.isArray(parsedValue.items) || !parsedValue.items.length) {
                localStorage.removeItem(pendingCartStorageKey);
                return null;
            }

            if (parsedValue.createdAt && (Date.now() - parsedValue.createdAt) > pendingCartMaxAgeMs) {
                localStorage.removeItem(pendingCartStorageKey);
                return null;
            }

            return parsedValue;
        } catch (error) {
            console.error("Modal pre-checkout: No se pudo leer pending cart snapshot", error);
            localStorage.removeItem(pendingCartStorageKey);
            return null;
        }
    }

    function clearPendingCartSnapshot() {
        try {
            localStorage.removeItem(pendingCartStorageKey);
        } catch (error) {
            console.error("Modal pre-checkout: No se pudo limpiar pending cart snapshot", error);
        }
    }

    function normalizeLineItemProperties(properties) {
        if (!properties || typeof properties !== "object") {
            return null;
        }

        const normalizedProperties = {};

        Object.keys(properties).forEach((key) => {
            const value = properties[key];

            if (value === null || typeof value === "undefined" || value === "") {
                return;
            }

            normalizedProperties[key] = String(value);
        });

        return Object.keys(normalizedProperties).length ? normalizedProperties : null;
    }

    function buildPendingCartItems(allCartItems, checkoutItems) {
        const selectedQuantitiesByKey = {};

        checkoutItems.forEach((item) => {
            if (!item || !item.key) {
                return;
            }

            selectedQuantitiesByKey[item.key] = (selectedQuantitiesByKey[item.key] || 0) + (parseInt(item.quantity, 10) || 0);
        });

        return allCartItems.map((item) => {
            const selectedQuantity = selectedQuantitiesByKey[item.key] || 0;
            const remainingQuantity = Math.max(0, (parseInt(item.quantity, 10) || 0) - selectedQuantity);

            if (!remainingQuantity) {
                return null;
            }

            const pendingItem = {
                id: item.variant_id,
                quantity: remainingQuantity
            };

            const normalizedProperties = normalizeLineItemProperties(item.properties);

            if (normalizedProperties) {
                pendingItem.properties = normalizedProperties;
            }

            if (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan && item.selling_plan_allocation.selling_plan.id) {
                pendingItem.selling_plan = item.selling_plan_allocation.selling_plan.id;
            } else if (item.selling_plan) {
                pendingItem.selling_plan = item.selling_plan;
            }

            return pendingItem;
        }).filter(Boolean);
    }

    function persistPendingCartItems(allCartItems, checkoutItems) {
        const pendingItems = buildPendingCartItems(allCartItems, checkoutItems);

        if (!pendingItems.length) {
            clearPendingCartSnapshot();
            return;
        }

        try {
            localStorage.setItem(pendingCartStorageKey, JSON.stringify({
                createdAt: Date.now(),
                items: pendingItems
            }));
        } catch (error) {
            console.error("Modal pre-checkout: No se pudo guardar pending cart snapshot", error);
        }
    }

    async function restorePendingCartIfNeeded() {
        const pendingCartSnapshot = getPendingCartSnapshot();

        if (!pendingCartSnapshot) {
            return false;
        }

        try {
            const cartResponse = await fetch("/cart.js");

            if (!cartResponse.ok) {
                throw new Error(`Error al cargar el carrito para restore: ${cartResponse.statusText}`);
            }

            const currentCart = await cartResponse.json();

            if (currentCart && currentCart.item_count > 0) {
                return false;
            }

            const restoreResponse = await fetch("/cart/add.js", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json"
                },
                body: JSON.stringify({
                    items: pendingCartSnapshot.items
                })
            });

            if (!restoreResponse.ok) {
                throw new Error(`Error al restaurar carrito: ${restoreResponse.statusText}`);
            }

            clearPendingCartSnapshot();
            window.location.reload();
            return true;
        } catch (error) {
            console.error("Modal pre-checkout: No se pudo restaurar el carrito pendiente", error);
            return false;
        }
    }

    // Usar event delegation en FASE DE CAPTURA para ejecutarnos ANTES que el handler de Shopify
    console.log("Modal pre-checkout: Configurando event delegation para botones de checkout");
    
    document.addEventListener("click", async function(event) {
        const checkoutSelectors = [
            "#checkout",
            "button[name='checkout']",
            "input[name='checkout']",
            ".checkout-button",
            ".checkout-btn",
            ".shopify-payment-button__button",
            "a.button--checkout",
            "a[href*='/checkout']",
            "[data-cc-checkout-button]"
        ];
        
        // Botón "Comprar ahora" (Shopify Payment Button) en página de producto
        const buyNowButton = event.target.closest(".shopify-payment-button__button");

        // Flujo para botón "Comprar ahora": agregar al carrito por AJAX y luego abrir modal
        if (buyNowButton) {
            console.log("Modal pre-checkout: Click en botón 'Comprar ahora' detectado");
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();

            const productForm = buyNowButton.closest('form[action^="/cart/add"]');
            if (!productForm) {
                console.error("Modal pre-checkout: No se encontró formulario de producto para 'Comprar ahora'");
                return;
            }

            try {
                const formData = new FormData(productForm);
                const body = new URLSearchParams(formData);

                const response = await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                    },
                    body: body.toString()
                });

                if (!response.ok) {
                    throw new Error('Error al agregar el producto al carrito');
                }

                console.log('Modal pre-checkout: Producto agregado al carrito desde \"Comprar ahora\"');

                // Notificar actualización del carrito para que el modal recargue los datos
                const cartItemAddedEvent = new CustomEvent('cart:item-added');
                document.dispatchEvent(cartItemAddedEvent);

                // Pequeña espera para asegurar que el carrito se haya actualizado antes de mostrar el modal
                setTimeout(() => {
                    showModal();
                }, 200);
            } catch (error) {
                console.error('Modal pre-checkout: Error en flujo \"Comprar ahora\" + modal', error);
            }

            return;
        }

        // Flujo normal de checkout (carrito, drawer, etc.)
        const isCheckoutButton = checkoutSelectors.some(sel => event.target.closest(sel));
        if (isCheckoutButton) {
            if (!canProceedWithSelectedGroup()) {
                event.preventDefault();
                event.stopPropagation();
                event.stopImmediatePropagation();
                return;
            }

            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
            showModal();
        }
    }, true);
    
    // También verificar si ya existen botones de checkout al cargar
    const existingCheckoutButtons = document.querySelectorAll("#checkout, button[name='checkout'], .checkout-button");
    console.log("Modal pre-checkout: Botones de checkout existentes encontrados:", existingCheckoutButtons.length);

    if (closeModalButton) closeModalButton.addEventListener("click", closeModal);
    if (backModalButton) backModalButton.addEventListener("click", closeModal);

    // Validaciones específicas para cada tipo de campo
    function validateEmail(email) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    }

    /** Teléfono genérico (7–15 dígitos; permite espacios, guiones y paréntesis en la captura). */
    function validatePhone(phone) {
        const digits = String(phone || "").replace(/\D/g, "");
        return digits.length >= 7 && digits.length <= 15;
    }

    function validateRequired(value) {
        return value.trim().length > 0;
    }

    function validateSelect(selectElement) {
        return selectElement.value && selectElement.value !== "";
    }



    function validateField(field, validationType, errorMessage) {
        if (!field?.parentNode) {
            return false;
        }

        let errorElement = field.parentNode.querySelector(".error-message");

        if (!errorElement) {
            errorElement = document.createElement("div");
            errorElement.classList.add("error-message");
            field.parentNode.appendChild(errorElement);
        }

        let isValid = false;
        const value = field.value ? field.value.trim() : "";

        if (value === "" && !field.hasAttribute('data-touched')) {
            field.classList.remove("input-error");
            errorElement.style.display = "none";
            errorElement.textContent = "";
            return false;
        }

        switch (validationType) {
            case 'email':
                isValid = validateEmail(value);
                break;
            case 'phone':
                isValid = validatePhone(value);
                break;
            case 'required':
                isValid = validateRequired(value);
                break;
            case 'select':
                isValid = validateSelect(field);
                break;
            default:
                isValid = validateRequired(value);
        }
    
        if (!isValid) {
            field.classList.add("input-error");
            errorElement.textContent = errorMessage;
            errorElement.style.display = "block";
            return false;
        } else {
            field.classList.remove("input-error");
            errorElement.style.display = "none";
            errorElement.textContent = "";
            return true;
        }
    }

    function validateForm() {
        const validations = [
            { field: emailInput, type: 'email', message: 'Ingresa un correo electrónico válido' },
            { field: firstNameInput, type: 'required', message: 'El nombre es requerido' },
            { field: lastNameInput, type: 'required', message: 'Los apellidos son requeridos' },
            { field: dniInput, type: 'required', message: 'El documento de identidad es obligatorio' },
            { field: addressInput, type: 'required', message: 'La dirección es requerida' },
            { field: phoneInput, type: 'phone', message: 'Ingresa un número de teléfono válido' },
            { field: level3Select, type: 'select', message: 'Selecciona una opción' },
            { field: level2Select, type: 'select', message: 'Selecciona una opción' },
            { field: level1Select, type: 'select', message: 'Selecciona una opción' }
        ];

        let allValid = true;
        validations.forEach(validation => {
            if (validation.field) {
                // Usar validateField para actualizar la apariencia visual
                if (!validateField(validation.field, validation.type, validation.message)) {
                    allValid = false;
                }
            }
        });
        if (saveCheckoutButton) {
            if (allValid) {
                saveCheckoutButton.disabled = false;
                saveCheckoutButton.style.opacity = "1";
                saveCheckoutButton.style.cursor = "pointer";
            } else {
                saveCheckoutButton.disabled = true;
                saveCheckoutButton.style.opacity = "0.5";
                saveCheckoutButton.style.cursor = "not-allowed";
            }
        }

        return allValid;
    }

    function setupInputLimits() {
        if (dniInput) {
            dniInput.setAttribute("maxlength", "32");
            dniInput.removeAttribute("pattern");
            dniInput.setAttribute("inputmode", "text");
        }
        if (phoneInput) {
            phoneInput.setAttribute("maxlength", "24");
            phoneInput.removeAttribute("pattern");
            phoneInput.setAttribute("inputmode", "tel");
        }

        if (firstNameInput) {
            firstNameInput.setAttribute('maxlength', '50');
        }
        if (lastNameInput) {
            lastNameInput.setAttribute('maxlength', '50');
        }
        if (addressInput) {
            addressInput.setAttribute('maxlength', '200');
        }
    }

    function isPrecheckoutModalOpen() {
        if (!modalElement) return false;
        const d = String(modalElement.style.display || "").toLowerCase().trim();
        return d !== "none" && d !== "";
    }

    function addValidationListeners() {
        if (validationListenersBound) {
            return;
        }
        validationListenersBound = true;

        const fields = [
            { element: emailInput, type: 'email', message: 'Ingresa un correo electrónico válido' },
            { element: firstNameInput, type: 'required', message: 'El nombre es requerido' },
            { element: lastNameInput, type: 'required', message: 'Los apellidos son requeridos' },
            { element: dniInput, type: 'required', message: 'El documento de identidad es obligatorio' },
            { element: addressInput, type: 'required', message: 'La dirección es requerida' },
            { element: phoneInput, type: 'phone', message: 'Ingresa un número de teléfono válido' },
            { element: level3Select, type: 'select', message: 'Selecciona una opción' },
            { element: level2Select, type: 'select', message: 'Selecciona una opción' },
            { element: level1Select, type: 'select', message: 'Selecciona una opción' }
        ];

        fields.forEach(field => {
            if (field.element) {
                if (field.element.tagName === 'INPUT') {
                    let timeout;
                    const handleInput = () => {
                        field.element.setAttribute('data-touched', 'true');
                        clearTimeout(timeout);
                        if (field.type === 'phone') {
                            validateField(field.element, field.type, field.message);
                            validateForm();
                            schedulePrecheckoutDraftSave();
                        } else {
                            timeout = setTimeout(() => {
                                validateField(field.element, field.type, field.message);
                                validateForm();
                                schedulePrecheckoutDraftSave();
                            }, 300);
                        }
                    };
                    field.element.addEventListener('input', handleInput);

                    field.element.addEventListener('blur', () => {
                        clearTimeout(timeout);
                        validateField(field.element, field.type, field.message);
                        validateForm();
                        schedulePrecheckoutDraftSave();
                    });
                    field.element.addEventListener('focusout', () => {
                        clearTimeout(timeout);
                        validateField(field.element, field.type, field.message);
                        validateForm();
                        schedulePrecheckoutDraftSave();
                    });
                }
                if (field.element.tagName === 'SELECT') {
                    const onSelectUpdate = () => {
                        applySelectValue(field.element, field.element.value);
                        field.element.setAttribute('data-touched', 'true');
                        validateField(field.element, field.type, field.message);
                        validateForm();
                        schedulePrecheckoutDraftSave();
                    };
                    field.element.addEventListener('change', onSelectUpdate);
                    field.element.addEventListener('input', onSelectUpdate);
                }
            }
        });
    }

    window.savePreCheckout = async function () {
        if (!validateForm()) {
            alert("Por favor, completa todos los campos requeridos correctamente antes de continuar.");
            return;
        }

        console.log("Formulario válido. Procesando datos...");

        savePrecheckoutDraft();

        const selectedProvinceText = level3Select?.options?.[level3Select.selectedIndex]?.text || "";
        const selectedProvinceValue = level3Select?.value || "";
        let selectedProvince = selectedProvinceText.toUpperCase();
        let provinceCode =
            resolveProvinceCode(selectedProvinceValue, diccionaryData.provincesMap) ||
            resolveProvinceCode(selectedProvinceText, diccionaryData.provincesMap);

        // Lógica especial para Lima (caso Perú, se mantiene por compatibilidad)
        if (selectedProvince === "LIMA") {
            console.log("Modal pre-checkout: Usuario seleccionó LIMA, redirigiendo a Lima (Metropolitan)");
            selectedProvince = "LIMA (METROPOLITAN)";
            provinceCode = "PE-LMA";
            console.log("Modal pre-checkout: Redirección completada - Provincia:", selectedProvince, "Código:", provinceCode);
        }

        console.log("Modal pre-checkout: Provincia seleccionada:", selectedProvince, "Código resuelto:", provinceCode);

        const formData = {
            email: emailInput?.value ?? "",
            firstName: firstNameInput?.value ?? "",
            lastName: lastNameInput?.value ?? "",
            dni: dniInput?.value ?? "",
            address: addressInput?.value ?? "",
            phone: phoneInput?.value ?? "",
            provinceCode: provinceCode,
            province: level3Select?.value ?? "",
            canton: level2Select?.value ?? "",
            level3String: selectedProvince,
            level2String: level2Select?.options?.[level2Select.selectedIndex]?.text?.toUpperCase(),
            district: level1Select?.value ?? "",
            level1String: level1Select?.options?.[level1Select.selectedIndex]?.text?.toUpperCase()
        };

        try {
            await updateCartWithPrecheckoutAttributes(formData);
            const checkoutItems = getCheckoutItems((cartData && cartData.items) || []);
            persistPendingCartItems((cartData && cartData.items) || [], checkoutItems);
            const checkoutUrl = await buildCheckoutUrl(formData);
            window.location.href = checkoutUrl;
        } catch (error) {
            console.error("Error al procesar en el checkout:", error);
            alert("Hubo un problema al procesar el checkout. Por favor, inténtalo de nuevo.");
        }
    };

    function buildPrecheckoutCartAttributes(formData) {
        const phoneClean = String(formData.phone || "").replace(/\D/g, "");
        return {
            address_firstName: formData.firstName || "",
            address_lastName: formData.lastName || "",
            address_email: formData.email || "",
            address_phone: phoneClean,
            address_address: formData.address || "",
            address_identification_number: formData.dni || "",
            address_level3_CODE: formData.provinceCode || "",
            address_level3: formData.province || "",
            address_level2: formData.canton || "",
            address_level2_string: formData.level2String || "",
            address_level3_string: formData.level3String || "",
            address_level1: formData.district || "",
            address_level1_string: formData.level1String || "",
            dni: formData.dni || "",
            country: diccionaryData.countries.PE || ""
        };
    }

    async function updateCartWithPrecheckoutAttributes(formData) {
        const base = buildPrecheckoutCartAttributes(formData);
        const attributes = {
            ...base,
            level_1: base.address_level1_string,
            level_2: base.address_level2_string,
            level_3: base.address_level3_string
        };
        const payload = { attributes: {} };
        for (const [key, value] of Object.entries(attributes)) {
            payload.attributes[key] = value == null ? "" : String(value);
        }

        const response = await fetch("/cart/update.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json"
            },
            body: JSON.stringify(payload)
        });

        if (!response.ok) {
            const errText = await response.text().catch(() => "");
            throw new Error(errText || `Error al actualizar el carrito (${response.status})`);
        }

        return response.json();
    }

    async function buildCheckoutUrl(formData) {
        const shopDomain = `https://${window.location.hostname}`;

        const attributes = buildPrecheckoutCartAttributes(formData);

        // Crear objeto de parámetros para URLSearchParams
        const params = new URLSearchParams();
        params.append('storefront', 'false');
        params.append('checkout[shipping_address][first_name]', attributes.address_firstName);
        params.append('checkout[shipping_address][last_name]', attributes.address_lastName);
        params.append('checkout[shipping_address][address1]', attributes.address_address);
        params.append('checkout[shipping_address][address2]', attributes.address_address);
        params.append('checkout[shipping_address][country]', attributes.country);
        params.append('checkout[shipping_address][province]', attributes.address_level3_CODE);
        params.append('checkout[shipping_address][city]', `${attributes.address_level2_string} - ${attributes.address_level1_string}`);
        params.append('checkout[shipping_address][phone]', attributes.address_phone);
        params.append('checkout[billing_address][first_name]', attributes.address_firstName);
        params.append('checkout[billing_address][last_name]', attributes.address_lastName);
        params.append('checkout[billing_address][address1]', attributes.address_address);
        params.append('checkout[billing_address][address2]', attributes.address_address);
        params.append('checkout[billing_address][country]', attributes.country);
        params.append('checkout[billing_address][province]', attributes.address_level3_CODE);
        params.append('checkout[billing_address][city]', `${attributes.address_level2_string} - ${attributes.address_level1_string}`);
        params.append('checkout[billing_address][phone]', attributes.address_phone);
        params.append('attributes[address_firstName]', attributes.address_firstName);
        params.append('attributes[address_lastName]', attributes.address_lastName);
        params.append('attributes[address_address]', attributes.address_address);
        params.append('attributes[country]', attributes.country);
        params.append('attributes[level_1]', attributes.address_level1_string);
        params.append('attributes[level_2]', attributes.address_level2_string);
        params.append('attributes[level_3]', attributes.address_level3_string);
        params.append('attributes[dni]', attributes.dni);
        params.append('attributes[address_phone]', attributes.address_phone);
        params.append('checkout[email]', attributes.address_email);

        if (!productsArray.length) {
            throw new Error('No hay productos seleccionados para checkout');
        }

        const checkoutUrl = `${shopDomain}/cart/${productsArray.join(",")}?${params.toString()}`;

        return checkoutUrl;
    }

    function savePrecheckoutDraft() {
        try {
            const optText = (sel) => {
                if (!sel || !sel.value || !sel.options || sel.selectedIndex < 0) return "";
                return (sel.options[sel.selectedIndex]?.text || "").trim();
            };
            const draft = {
                email: emailInput?.value ?? "",
                firstName: firstNameInput?.value ?? "",
                lastName: lastNameInput?.value ?? "",
                dni: dniInput?.value ?? "",
                address: addressInput?.value ?? "",
                phone: phoneInput?.value ?? "",
                level3: level3Select?.value ?? "",
                level2: level2Select?.value ?? "",
                level1: level1Select?.value ?? "",
                level3Name: optText(level3Select),
                level2Name: optText(level2Select),
                level1Name: optText(level1Select),
                geoCountry: geographicData?.countryAlfa2ISO3166 ? String(geographicData.countryAlfa2ISO3166) : ""
            };
            const serialized = JSON.stringify(draft);
            for (const key of PRECHECKOUT_DRAFT_STORAGE_KEYS) {
                localStorage.setItem(key, serialized);
            }
        } catch (e) {
            console.warn("Modal pre-checkout: no se pudo guardar borrador", e);
        }
    }

    function schedulePrecheckoutDraftSave() {
        clearTimeout(precheckoutDraftSaveTimer);
        precheckoutDraftSaveTimer = setTimeout(savePrecheckoutDraft, 400);
    }

    function applyGeographicData(data) {
        const prev3 = level3Select ? gid(level3Select.value) : "";
        const prev2 = level2Select ? gid(level2Select.value) : "";
        const prev1 = level1Select ? gid(level1Select.value) : "";

        geographicData = data;
        populateSelect(level3Select, data.thirdLevel, "idLevels3", "level3Name");

        const canKeep3 = prev3 && data.thirdLevel.some((t) => gid(t.idLevels3) === prev3);
        if (canKeep3 && level3Select) {
            applySelectValue(level3Select, prev3);
            handleLevelChange(geographicData, "level3");
            const level2Options = data.thirdLevel.find((item) => gid(item.idLevels3) === prev3)?.secondLevel || [];
            const canKeep2 = prev2 && level2Options.some((s) => gid(s.idLevel2) === prev2);
            if (canKeep2 && level2Select) {
                applySelectValue(level2Select, prev2);
                handleLevelChange(geographicData, "level2");
                const level3Data = data.thirdLevel.find((item) => gid(item.idLevels3) === prev3);
                const level1Options = level3Data?.secondLevel.find((item) => gid(item.idLevel2) === prev2)?.firstLevel || [];
                const canKeep1 = prev1 && level1Options.some((f) => gid(f.idLevel1) === prev1);
                if (canKeep1 && level1Select) {
                    applySelectValue(level1Select, prev1);
                }
            }
        } else {
            if (level2Select) {
                level2Select.innerHTML = `<option value="">Seleccione una opción</option>`;
            }
            if (level1Select) {
                level1Select.innerHTML = `<option value="">Seleccione una opción</option>`;
            }
        }
    }

    function bindGeographicListenersOnce() {
        if (geographicListenersBound || !level3Select || !level2Select) return;
        geographicListenersBound = true;
        level3Select.addEventListener("change", () => {
            handleLevelChange(geographicData, "level3");
            applySelectValue(level3Select, level3Select.value);
            schedulePrecheckoutDraftSave();
        });
        level2Select.addEventListener("change", () => {
            handleLevelChange(geographicData, "level2");
            applySelectValue(level2Select, level2Select.value);
            schedulePrecheckoutDraftSave();
        });
    }

    async function loadGeographicLevelsFromNetwork() {
        const geographicUrl = window.theme?.settings?.geographic_levels_url || "/assets/geographicLevels.json";
        const response = await fetch(geographicUrl);
        if (!response.ok) throw new Error(`Error al cargar archivo de niveles geográficos: ${response.statusText}`);
        const data = await response.json();
        localStorage.setItem(GEO_LEVELS_STORAGE_KEY, JSON.stringify(data));
        applyGeographicData(data);
        bindGeographicListenersOnce();
    }

    async function ensureGeographicMatchesDraft(draft) {
        if (!draft) return;
        const hasLevelHint = !!(gid(draft.level3) || normName(draft.level3Name));
        if (!hasLevelHint) return;

        let mismatch = false;
        const wantCountry = normName(draft.geoCountry);
        const haveCountry = normName(geographicData?.countryAlfa2ISO3166);

        if (wantCountry && haveCountry && wantCountry !== haveCountry) {
            mismatch = true;
        } else if (!geographicData?.thirdLevel) {
            mismatch = true;
        } else if (gid(draft.level3) && !geographicData.thirdLevel.some((t) => gid(t.idLevels3) === gid(draft.level3))) {
            mismatch = true;
        }

        if (!mismatch) return;

        try {
            localStorage.removeItem(GEO_LEVELS_STORAGE_KEY);
            await loadGeographicLevelsFromNetwork();
        } catch (e) {
            console.warn("Modal pre-checkout: no se pudo recargar niveles geográficos", e);
        }
    }

    function resolveLevel2Id(draft, level2Options) {
        let id2 = gid(draft.level2);
        if (id2 && !level2Options.some((s) => gid(s.idLevel2) === id2)) {
            id2 = "";
        }
        if (!id2 && normName(draft.level2Name)) {
            const n2 = normName(draft.level2Name);
            const hit2 = level2Options.find((s) => normName(s.level2Name) === n2);
            if (hit2) id2 = gid(hit2.idLevel2);
        }
        return id2;
    }

    function resolveLevel1Id(draft, level1Options) {
        let id1 = gid(draft.level1);
        if (id1 && !level1Options.some((f) => gid(f.idLevel1) === id1)) {
            id1 = "";
        }
        if (!id1 && normName(draft.level1Name)) {
            const n1 = normName(draft.level1Name);
            const hit1 = level1Options.find((f) => normName(f.level1Name) === n1);
            if (hit1) id1 = gid(hit1.idLevel1);
        }
        return id1;
    }

    function isDraftNameMatchingRegion(name) {
        const n = normName(name);
        if (!n || !geographicData?.thirdLevel) return false;
        return geographicData.thirdLevel.some((t) => normName(t.level3Name) === n);
    }

    /** Algunas integraciones guardan la región en level1 y la comuna en level3; nuestro modelo es level3=región. */
    function alignDraftLevelsForGeoModel(draft) {
        if (!draft || !geographicData?.thirdLevel) return draft;
        const l1IsRegion = isDraftNameMatchingRegion(draft.level1Name);
        const l3IsRegion = isDraftNameMatchingRegion(draft.level3Name);
        if (l1IsRegion && !l3IsRegion) {
            return {
                ...draft,
                level1: "",
                level1Name: draft.level3Name != null ? String(draft.level3Name) : "",
                level3: "",
                level3Name: draft.level1Name != null ? String(draft.level1Name) : ""
            };
        }
        return draft;
    }

    function restoreGeographicLevelsFromDraft(draft) {
        if (!geographicData?.thirdLevel || !level3Select) return;

        const aligned = alignDraftLevelsForGeoModel({ ...draft });

        let id3 = gid(aligned.level3);

        if (!id3 && normName(aligned.level3Name)) {
            const n3 = normName(aligned.level3Name);
            const hit3 = geographicData.thirdLevel.find((t) => normName(t.level3Name) === n3);
            if (hit3) id3 = gid(hit3.idLevels3);
        }
        if (!id3) return;
        if (!geographicData.thirdLevel.some((t) => gid(t.idLevels3) === id3)) return;

        applySelectValue(level3Select, id3);
        handleLevelChange(geographicData, "level3");

        const level2Options = geographicData.thirdLevel.find((item) => gid(item.idLevels3) === id3)?.secondLevel || [];
        if (!level2Options.length || !level2Select) {
            const syncL3 = () => applySelectValue(level3Select, id3);
            queueMicrotask(syncL3);
            requestAnimationFrame(syncL3);
            return;
        }

        const id2 = resolveLevel2Id(aligned, level2Options);
        if (!id2) {
            const syncL3only = () => applySelectValue(level3Select, id3);
            queueMicrotask(syncL3only);
            requestAnimationFrame(syncL3only);
            return;
        }

        applySelectValue(level2Select, id2);
        handleLevelChange(geographicData, "level2");

        const level3Data = geographicData.thirdLevel.find((item) => gid(item.idLevels3) === id3);
        const level1Options = level3Data?.secondLevel.find((item) => gid(item.idLevel2) === id2)?.firstLevel || [];
        if (!level1Options.length || !level1Select) {
            const syncL32 = () => {
                applySelectValue(level3Select, id3);
                applySelectValue(level2Select, id2);
            };
            queueMicrotask(syncL32);
            requestAnimationFrame(syncL32);
            return;
        }

        const id1 = resolveLevel1Id(aligned, level1Options);
        if (!id1) {
            const syncL32b = () => {
                applySelectValue(level3Select, id3);
                applySelectValue(level2Select, id2);
            };
            queueMicrotask(syncL32b);
            requestAnimationFrame(syncL32b);
            return;
        }

        applySelectValue(level1Select, id1);

        const syncGeoSelectUi = () => {
            applySelectValue(level3Select, id3);
            applySelectValue(level2Select, id2);
            applySelectValue(level1Select, id1);
        };
        queueMicrotask(syncGeoSelectUi);
        requestAnimationFrame(syncGeoSelectUi);
    }

    function restorePrecheckoutDraft() {
        const draft = peekPrecheckoutDraft();
        if (!draft || typeof draft !== "object") return;

        if (emailInput) emailInput.value = draft.email || "";
        if (firstNameInput) firstNameInput.value = draft.firstName || "";
        if (lastNameInput) lastNameInput.value = draft.lastName || "";
        if (dniInput) dniInput.value = draft.dni || "";
        if (addressInput) addressInput.value = draft.address || "";
        if (phoneInput) phoneInput.value = draft.phone || "";

        restoreGeographicLevelsFromDraft(draft);

        const markTouched = (el) => {
            if (el && el.value) el.setAttribute("data-touched", "true");
        };
        markTouched(emailInput);
        markTouched(firstNameInput);
        markTouched(lastNameInput);
        markTouched(dniInput);
        markTouched(addressInput);
        markTouched(phoneInput);
        markTouched(level3Select);
        markTouched(level2Select);
        markTouched(level1Select);

        validateForm();
    }

    async function fetchGeographicLevels() {
        try {
            const cachedData = localStorage.getItem(GEO_LEVELS_STORAGE_KEY);
            if (cachedData) {
                console.log("Cargando niveles desde localStorage");
                const data = JSON.parse(cachedData);
                applyGeographicData(data);
                bindGeographicListenersOnce();
                return;
            }

            console.log("Cargando niveles desde archivo local");
            await loadGeographicLevelsFromNetwork();
        } catch (error) {
            console.error("Error al cargar niveles geográficos:", error.message);
        }
    }

    function handleLevelChange(data, level) {
        if (!data?.thirdLevel) return;

        if (level === "level3") {
            const selectedLevel3 = gid(level3Select.value);
            const level2Options = data.thirdLevel.find((item) => gid(item.idLevels3) === selectedLevel3)?.secondLevel || [];
            populateSelect(level2Select, level2Options, "idLevel2", "level2Name");
            if (level1Select) {
                level1Select.innerHTML = `<option value="">Seleccione una opción</option>`;
            }
        } else if (level === "level2") {
            const selectedLevel3 = gid(level3Select.value);
            const selectedLevel2 = gid(level2Select.value);
            const level3Data = data.thirdLevel.find((item) => gid(item.idLevels3) === selectedLevel3);
            const level1Options = level3Data?.secondLevel.find((item) => gid(item.idLevel2) === selectedLevel2)?.firstLevel || [];
            populateSelect(level1Select, level1Options, "idLevel1", "level1Name");
        }
    }

    function populateSelect(selectElement, options, valueKey, labelKey) {
        if (!selectElement) return;
        const frag = document.createDocumentFragment();
        const emptyOpt = document.createElement("option");
        emptyOpt.value = "";
        emptyOpt.textContent = "Seleccione una opción";
        frag.appendChild(emptyOpt);
        (options || []).forEach((option) => {
            const newOption = document.createElement("option");
            newOption.value = gid(option[valueKey]);
            newOption.textContent = option[labelKey];
            frag.appendChild(newOption);
        });
        selectElement.replaceChildren(frag);
    }

    async function loadCartData() {
        try {
            const response = await fetch("/cart.js");
            if (!response.ok) throw new Error(`Error al cargar el carrito: ${response.statusText}`);

            cartData = await response.json();
            const checkoutItems = getCheckoutItems(cartData.items);
            const checkoutTotal = checkoutItems.reduce((sum, item) => sum + item.line_price, 0);

            renderCartItems(checkoutItems);
            renderCartTotal(checkoutTotal);
        } catch (error) {
            console.error("Error al cargar el carrito:", error);
        }
    }

    function renderCartItems(items) {
        itemsCartContainer.innerHTML = "";
        if (items.length === 0) {
            itemsCartContainer.innerHTML = `<p>Tu carrito está vacío.</p>`;
            return;
        }

        productsArray = items.map(item => `${item.variant_id}:${item.quantity}`);
        items.forEach(item => {
            const itemElement = document.createElement("a");
            itemElement.classList.add("item-cart-summary-popup");
            itemElement.href = item.url;
            itemElement.innerHTML = `
                <div class="image-cart-summary-popup">
                    <img src="${item.image}" alt="${item.title}">
                </div>
                <div class="info-item-cart-summary-popup">
                    <span class="title-item-cart-pop-up">${item.title}</span>
                    <span class="price-item-cart-pop-up">${formatPrice(item.line_price)}</span>
                    <span class="variant-item-cart-pop-up">Talla: ${item.variant_title}</span>
                    <span class="cant-item-cart-pop-up">Cant: ${item.quantity}</span>
                </div>
            `;
            itemsCartContainer.appendChild(itemElement);
        });
    }

    function renderCartTotal(totalPrice) {
        totalPriceContainer.textContent = formatPrice(totalPrice);
    }

    function formatPrice(price) {
        return isNaN(price)
            ? "$0"
            : new Intl.NumberFormat("es-PE", { style: "currency", currency: "PEN", minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(price / 100);
    }

    // Inicializar el botón como deshabilitado
    if (saveCheckoutButton) {
        saveCheckoutButton.disabled = true;
        saveCheckoutButton.style.opacity = "0.5";
        saveCheckoutButton.style.cursor = "not-allowed";
    }

    const restoredPendingCart = await restorePendingCartIfNeeded();

    if (restoredPendingCart) {
        return;
    }

    await fetchGeographicLevels();
    await loadCartData();
    setupInputLimits(); // Configurar límites físicos en los inputs
    addValidationListeners(); // Agregar listeners de validación después de que los campos estén en el DOM
    
    // Función global para reinicializar el modal cuando el carrito se actualice
    window.reinitializeModalPrecheckout = async function() {
        console.log("Modal pre-checkout: Reinicializando después de actualización del carrito");
        if (isPrecheckoutModalOpen()) {
            if (modalOpenCartRefreshTimer) {
                clearTimeout(modalOpenCartRefreshTimer);
            }
            modalOpenCartRefreshTimer = setTimeout(async () => {
                modalOpenCartRefreshTimer = null;
                await loadCartData();
            }, 400);
            return;
        }
        await loadCartData();
        setupInputLimits();
        addValidationListeners();
    };
    
    // Interceptar eventos de actualización del carrito
    document.addEventListener('cart:refresh', async function(event) {
        console.log("Modal pre-checkout: Evento cart:refresh detectado");
        // Esperar un poco para que el DOM se actualice
        setTimeout(async () => {
            await window.reinitializeModalPrecheckout();
        }, 100);
    });
    
    document.addEventListener('cart:item-added', async function(event) {
        console.log("Modal pre-checkout: Evento cart:item-added detectado");
        // Esperar un poco para que el DOM se actualice
        setTimeout(async () => {
            await window.reinitializeModalPrecheckout();
        }, 200);
    });
    
    console.log("Modal pre-checkout: Configuración completada");
});
